<template>
  <b-overlay :show="loading" rounded>
    <header v-if="myGudang">
      <h5>
        <strong>Lokasi Gudang: {{ this.myGudang.nama_gudang }}</strong>
      </h5>
    </header>
    <b-row>
      <b-col md="2" sm="12">
            <p><strong>Tanggal</strong></p>
            <p>{{ so.tanggal }}</p>
          </b-col>
      <b-col md="2" sm="12">
            <p><strong>No</strong></p>
            <p>{{ so.no }}</p>
          </b-col>
          <b-col md="5" sm="12">
            <p><strong>Keterangan</strong></p>
            <p>{{ so.keterangan ? so.keterangan : "-" }}</p>
          </b-col>
          <b-col md="3" sm="12" v-if="so.status == 0">
            <p><strong>Status</strong></p>
            <b-badge variant="light-danger" size="sm"
              >Belum Selesai</b-badge
            >
          </b-col>
          <b-col md="3" sm="12" v-if="so.status == 1">
            <p><strong>Status</strong></p>
            <b-badge variant="light-success" size="sm"
              >Selesai</b-badge
            >
          </b-col>

      <!-- Input Stock Opname -->
      <b-col>
        <b-card style="overflow-y: auto; max-height: 500px">
          <b-table small bordered striped hover responsive :fields="fields" :items="penyimpanan_id">
            <template #cell(no)="row">
              <div class="text-center">
                {{ row.index + 1 }}
              </div>
            </template>
            <template #cell(jumlah)="{ item }">
              <b-form-input type="number" v-model="item.jumlah" />
            </template>
            <template #cell(so)="{ item }">
              {{ item.id_stok_opname }}
            </template>
            <template #cell(selisih)="{ item }">
              {{ item.jumlah - item.stok }}
            </template>

            <!-- <template #cell(actions)="row">
              <b-link class="text-danger" @click.prevent="barangs.splice(row.index, 1)">
                <feather-icon size="24" svgClasses="text-success" icon="XCircleIcon" />
              </b-link>
            </template> -->
          </b-table>
        </b-card>
      </b-col>
      <!-- / -->
    </b-row>
    <footer class="d-flex justify-content-end">
      <b-button v-if="so.status == 0" variant="primary" @click.prevent="save">Simpan</b-button>
      <!-- <b-button variant="info" @click.prevent="resetform">Reset</b-button> -->
    </footer>
  </b-overlay>
</template>
<script>
import {
  BRow,
  BCol,
  BButton,
  BForm,
  BCard,
  BFormGroup,
  BFormSelect,
  BOverlay,
  BTable,
  BFormInput,
  BLink,
    BBadge,
} from "bootstrap-vue";
import vSelect from "vue-select";
export default {
  components: {
    BRow,
    BCol,
    BButton,
    BForm,
    BCard,
    BFormGroup,
    BFormSelect,
    BOverlay,
    vSelect,
    BTable,
    BFormInput,
    BLink,
    BBadge,
  },
  data() {
    return {
      loading: false,
      selectedBarang: null,
      barangs: [],
      penyimpanan_id: [],
      jumlah: 0,
      stok: 0,
      id_stok_opname: 0,
      status: 1,
      so: {
        tanggal: null,
        no: null,
        keterangan: null,
        status: null,
      },
      userData: JSON.parse(localStorage.getItem("userData")),
      fields: [
        {
          key: "no",
          label: "No",
        },
        {
          key: "barang.nama",
          label: "Nama Barang",
          sortable: true
        },
        {
          key: "blok.blok",
          label: "Blok",
          sortable: true
        },
        {
          key: "palet.palet",
          label: "palet",
        },
        {
          key: "rak.rak",
          label: "rak",
        },
        {
          key: "laci.laci",
          label: "laci",
        },
        {
          key: "stok",
          label: "Stok",
        },
        {
          key: "barang.satuan.satuan",
          label: "satuan",
        },
        {
          key: "jumlah",
          label: "Hasil Stok Opname",
        },
        {
          key: "selisih",
          label: "selisih barang",
        }
      ],
    };
  },
  mounted() {
    this.getData()
    this.getDataSo()
    if (this.$route.params.id) {
      this.id_stok_opname = this.$route.params.id;
    }
  },
  methods: {
    resetform() {
      this.item.jumlah = 0;
      this.jumlah = 0;
    },
    async save() {
      if (this.id) {
        this.id = this.id
      }
      let payloads = []
      this.penyimpanan_id.map(item => {
        payloads.push({
          id_stok_opname: this.$route.params.id,
          id_penyimpanan: item.id,
          stok: item.stok,
          jumlah: item.jumlah
        })
      })
      let payload1 = {
        status: this.status
      }
      if (this.$route.params.id) {
            payload1.id = this.$route.params.id;
          }
      try {
        this.loading = true
        await this.$store.dispatch('stokopname/saveSo', payloads)
        await this.$store.dispatch('stokopname/save', [payload1])
        this.loading = false

        this.displaySuccess({
          message: 'Stok Opname berhasil disimpan!'
        })
        this.getData();
        setTimeout(() => {
            this.loading = false;
            this.$router.push({ name: 'stock-opname-rincian', params: { id: this.$route.params.id } });
          }, 1000);
      } catch (e) {
        this.loading = false;
        this.displayError(e);
        return false;
      }
    },
    async getData() {
      const params = {}
      if(this.myGudang) params.gudang_id = this.myGudang.id


      const stocks = await this.$store.dispatch("penyimpanan/getData", params)
      stocks.map(stock => {
        stock.jumlah = 0
      })
      this.penyimpanan_id = JSON.parse( JSON.stringify(stocks) )
      this.totalRows = JSON.parse( JSON.stringify(stocks) ).length
    },
    getDataSoRincian() {
      if (this.user.level.id == 0) {
      this.$store
        .dispatch("stokopname/getDataSo", { id_stok_opname: this.$route.params.id })
        .then(() => {
          this.items = this.$store.state.stokopname.datas;
          this.totalRows = this.items.length;
        })
        .catch((e) => {
          this.displayError(e);
          return false;
        });
      }
    },
    async getDataSo() {
      const so = await this.$store
        .dispatch("stokopname/getDataById", this.$route.params.id);
          this.so = so;
    }
  },
  watch: {
    selectedBarang(barang) {
      if (barang) {
        this.barangs.push({
          id: barang.value,
          name: barang.text,
          jumlah: 0,
          isFinalStock: false,
        });
      }
    },
  },
};
</script>
